import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,_vm._b({staticClass:"text-capitalize",attrs:{"href":_vm.href}},'v-btn',_vm.$attrs,false),[_vm._t("button",[_vm._v("Let Peeps Know")]),(_vm.icon)?_c(VIcon,[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }